// extracted by mini-css-extract-plugin
export default {"params":"Params_params__jtbQ7"};